import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { Document } from "../types/document";
import { ImageProps } from "../types/image";
import { ProductUpdate } from "../types/product";

export type SelectedCustomer = {
    customerId: string;
    price: number | string | undefined;
    customerName?: string
};
type ProductManagementSlice = {
    product: ProductUpdate,
    originalProduct: ProductUpdate | null,
    // Name, Art.-Nr. and unit of the connected materials the product was loaded with, so the
    // Zubehör tab can list them without the picker having paged them in.
    relatedProductDetails: any[],
    temporaryDocuments: ImageProps[]
    documents: Document[]
}
const initialState: ProductManagementSlice = {
    product: {
        name: "",
        referenceNumber: "",
        salesUnitId: "",
        description: "",
        internalNote: "",
        price: { price: "", purchasePrice: "" },
        relatedProducts: [],
        extendedPrices: []
    },
    originalProduct: null,
    relatedProductDetails: [],
    temporaryDocuments: [],
    documents: []
};

export const productManagementSlice = createSlice({
    name: 'productManagement',
    initialState,
    reducers: {
        setProductName: (state, { payload }: PayloadAction<string>) => {
            state.product.name = payload;
        },
        setReferenceNumber: (state, { payload }: PayloadAction<string>) => {
            state.product.referenceNumber = payload;
        },
        setDescription: (state, { payload }: PayloadAction<string>) => {
            state.product.description = payload;
        },
        setInternalNote: (state, { payload }: PayloadAction<string>) => {
            state.product.internalNote = payload;
        },
        setPurchasePrice: (state, { payload }: PayloadAction<number | string>) => {
            state.product.price.purchasePrice = payload;
        },
        setPrice: (state, { payload }: PayloadAction<number | string>) => {
            state.product.price.price = payload;
        },
        setSalesUnitId: (state, { payload }: PayloadAction<string>) => {
            state.product.salesUnitId = payload;
        },
        setSelectedProductIds: (state, action: PayloadAction<string[]>) => {
            state.product.relatedProducts = action.payload;
        },

        setExtendedPrices: (state, { payload }: PayloadAction<SelectedCustomer[]>) => {
            state.product.extendedPrices = payload;
        },
        addDocument: (state, action) => {
            state.temporaryDocuments.push(action.payload);
        },

        removeDocument: (state, action) => {
            state.temporaryDocuments = state.temporaryDocuments.filter(
                (document) => document.id !== action.payload
            );
        },

        clearDocuments: (state) => {
            state.temporaryDocuments = [];
            state.documents = [];
        },
        setEditProduct(state, { payload }: PayloadAction<any>) {
            state.product = structuredClone(payload);
            state.originalProduct = structuredClone(payload);
        },
        setDocuments(state, { payload }: PayloadAction<any>) {
            state.documents = payload;
        },
        setRelatedProductDetails(state, { payload }: PayloadAction<any[]>) {
            state.relatedProductDetails = payload;
        },
        // A pending upload that has been saved moves over to the stored documents, so a retry
        // after a partial failure does not upload it twice.
        documentUploaded: (state, { payload }: PayloadAction<{ temporaryId: string, document: Document }>) => {
            state.temporaryDocuments = state.temporaryDocuments.filter(
                (document) => document.id !== payload.temporaryId
            );
            state.documents.push(payload.document);
        },
        removeIncludeDocument: (state, action) => {
            state.documents = state.documents.filter(
                (document) => document.id !== action.payload
            );
        },
        resetState() {
            return { ...initialState };
        },
    }
});

export const productManagementActions = productManagementSlice.actions;